import React from "react";
import PropTypes from "prop-types";
import {FLIP_ICON_TYPE} from "../../containers/FlipMatch/constants";

class FlipMatchCard extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            focused: props.focused,
        }
    }

    handleClick = () => {
        const {props} = this;
        props.onClick(props);
    }

    handleFocus = () => {
        this.setState({ focused: true })
    }

    handleUnfocus = () => {
        this.setState({ focused: false })
    }

    render() {
        const { className, value, name, frontIcon, frontText, backIcon, backText, theme, flipped, selected, current } = this.props;
        const { focused } = this.state;
        const wrapperClasses = `flip-container 
            ${focused ? 'focused' : ''} 
            ${flipped ? 'flipped' : ''} 
            ${selected ? 'selected' : ''} 
            ${current ? 'current' : ''}
            ${theme ? `theme-${theme}` : ``}
        `;
        const BackIconTag = backIcon.tag;
        const FrontIconTag = frontIcon.tag;

        return (
            <div className={className}>
                <button
                    type="button"
                    name={name}
                    value={value}
                    className={wrapperClasses}
                    onClick={this.handleClick}
                    onMouseEnter={this.handleFocus}
                    onMouseLeave={this.handleUnfocus}
                >
                    <div className="flipper">
                        <div className="back">
                            {BackIconTag &&
                                <BackIconTag {...backIcon.props} />
                            }
                            <div className="back-text">{backText}</div>
                        </div>
                        <div className="front">
                            {FrontIconTag &&
                                <FrontIconTag {...frontIcon.props} />
                            }
                            {frontText &&
                                <div className="front-text">{frontText}</div>
                            }
                        </div>
                    </div>
                </button>
            </div>
        )
    }
}

FlipMatchCard.propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    theme: PropTypes.string.isRequired,
    frontText: PropTypes.string,
    frontIcon: FLIP_ICON_TYPE,
    backText: PropTypes.string,
    backIcon: FLIP_ICON_TYPE,
    focused: PropTypes.bool,
    selected: PropTypes.bool,
    flipped: PropTypes.bool,
    current: PropTypes.bool
};

FlipMatchCard.defaultProps = {
    className: '',
    focused: false,
    selected: false,
    flipped: false,
    current: false,
    frontText: '',
    frontIcon: false,
    backText: '',
    backIcon: false,
};

export default FlipMatchCard;